import styled from "styled-components";

import { colors } from "../themes/base";

const ToolsHeaderText = styled.p`
  opacity: 0.5;
  color: ${colors.secondary};
  font-family: Muli;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 15px;
  text-transform: uppercase;
  margin: 10px;
`;

export default ToolsHeaderText;
